import AbstractSystem from "../all/AbstractSystem";

class SonySystem extends AbstractSystem {
    
    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default SonySystem;



// WEBPACK FOOTER //
// ./src/devices/sony/System.js